/*
 * @Author: Roman
 * @Date: 2022-12-12 16:37:17
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-01-08 17:12:39
 * @FilePath: \qpmn-site\src\app\modules\basic\page\page-object-tree.service.ts
 * @Description: 
 */
import { IError, IResponseEvent, IToken } from "@core/data-access/model";
import { IStorageService } from "@core/storage";
import { ILoginCacheKey, IPageObjectTreeService, PageCacheKey } from "."
import { IAnonymousLoginCacheKey } from "./login-cache-key";
import { ILoggerObjectTree, ILoggerUserInfo } from "@core/logger/types";
import { IUserDataService } from "@modules/user/service/data/i-user-data-service";
import { IPageInitObjectTreeService, UserPreferences } from "./page-object-tree";
import { envConfig } from "@env/env-config";
import { IHeaderObjectTreeService } from "@modules/main/header/header-object-tree";
import { IUserData } from "@modules/user/rest/data/user-data-proxy";
import { LocalStorageKeyEnum } from "@modules/main/LocalStorageKeyEnum";
import is from "@core/comparators/is";
import { Store } from "@modules/store/stores/model/domain/Store";

export abstract class PageObjectTreeService implements IPageObjectTreeService, ILoggerObjectTree, IPageInitObjectTreeService {

    public abstract storageService: IStorageService<PageCacheKey>;

    public USE_TEST_VERSION: boolean = false;

    // public header: { 
    //     getFirstName(): string;
    //     getCartQty(): string;
    //     clearLogin(): void;
    //     isAnonymous(): boolean;
    //     setAnonymous(isAnonymous: boolean, anonymousUserId?: string): void; 
    // };

    private _UserDataService?: IUserDataService;

    private _UserPreference: UserPreferences;

    constructor() {
        if (/\/stage/.test(window.location.pathname)) {
            this.USE_TEST_VERSION = true;
        }

        // this.initHeaderFn();
    }

    setCurrentPreference(preference: UserPreferences) {
        this._UserPreference = preference;
    }

    getCurrentPreference(): UserPreferences {
        // todo: 降级处理
        // 优先级：
        // 1.请求获取的偏好设置
        // 2.缓存中的偏好设置
        // 3.网站默认偏好设置
        if (!this._UserPreference) {
            let currencyCode = this.storageService.getItem("currencyCode") || envConfig.DEFAULT_CURRENCY;
            // let cartNumber = this.storageService.getItem("CartNumber") ? Number(this.storageService.getItem("CartNumber")) : 0;
            // let languageCode = this.storageService.getItem("languageCode") || appConifg.DEFAULT_LANGUAGE;

            this._UserPreference = {
                currencyCode: currencyCode,
                // cartNumber: cartNumber,
                // languageCode: languageCode
            }
        }

        return this._UserPreference;
    }

    setUserDataService(userDataService: IUserDataService) {
        this._UserDataService = userDataService;
    }

    get userPreference(): angular.IPromise<IUserData> {
        if (this._UserDataService) {
            return this._UserDataService.getUserDataWithoutCache();
        } else {
            throw new Error("未注入userDataService");
        }
    }

    get useTestVersion(): boolean {
        return this.USE_TEST_VERSION;
    }

    /**
     * @description 从localStore获取token缓存,若未登录则返回undefined
     */
    get token(): IToken | undefined {
        let tokenType = this.storageService.getItem("TokenType");
        let accessToken = this.storageService.getItem("Token");

        if (accessToken == null || tokenType == null) {
            return undefined;
        } else {
            return {
                token_type: tokenType,
                access_token: accessToken,
            };
        }
    }

    getCache(key: PageCacheKey): string | null {
        return this.storageService.getItem(key);
    }

    setCache(key: PageCacheKey, value: string): void {
        this.storageService.setItem(key, value);
    }

    getUserName(): string {
        // 读取缓存
        let userName = this.getCache("UserName");
        return userName || "";
    }

    setLogin(loginCacheKey: ILoginCacheKey): void {
        this.setCache("firstName", loginCacheKey.firstName);
        this.setCache("UserName", loginCacheKey.userName);
        this.setCache("Token", loginCacheKey.token);
        this.setCache("TokenType", loginCacheKey.tokenType);
        this.setCache("IsAnonymous", loginCacheKey.isAnonymous.toString());
        this.setCache("PartnerType", loginCacheKey.partnerType);

        if (loginCacheKey.expire) {
            let currentDate = new Date().getTime();
            let expireDate = loginCacheKey.expire * 1000 + currentDate;
            this.setCache("expire", expireDate.toString());
        }

        if (loginCacheKey.anonymousUserId) {
            this.setCache("AnonymousUserId", loginCacheKey.anonymousUserId);
        }
        // 清空店铺列表缓存数据
        this.clearStoreList();

    }

    setAnonymousLogin(loginCacheKey: IAnonymousLoginCacheKey): void {
        this.setCache("Token", loginCacheKey.token);
        this.setCache("TokenType", loginCacheKey.tokenType);
        this.setCache("IsAnonymous", loginCacheKey.isAnonymous.toString());

        if (loginCacheKey.expire) {
            let currentDate = new Date().getTime();
            let expireDate = loginCacheKey.expire * 1000 + currentDate;
            this.setCache("expire", expireDate.toString());
        }

        if (loginCacheKey.anonymousUserId) {
            this.setCache("AnonymousUserId", loginCacheKey.anonymousUserId);
        }
        // 清空店铺列表缓存数据
        this.clearStoreList();
    }

    /**
     * @description 清除登录状态
     */
    public clearLogin(): void {
        this.removeCache("UserName");
        this.removeCache("Token");
        this.removeCache("TokenType");
        this.removeCache("CartNumber");
        this.removeCache("expire");
        this.removeCache('StoreList');
        this.removeCache('StoreListExpire');

        this.setCache("IsAnonymous", "true");
    }

    removeCache(key: PageCacheKey): void {
        this.storageService.removeItem(key);
    }

    /**
     * @description 获取当前/登录前的匿名用户id
     * 若从未登录则返回0
     * @returns 
     */
    public getAnonymousUserId(): number {
        // todo: 70或73环境标识
        let anonymousUserIdStorage = this.getCache("AnonymousUserId");

        return anonymousUserIdStorage != null ? new Number(anonymousUserIdStorage).valueOf() : 0;
    }

    /**
     * @description 判断当前是否是匿名用户
     */
    public isAnonymous(): boolean {
        let isAnonymousStorage = this.getCache("IsAnonymous");

        return isAnonymousStorage == null ? true : isAnonymousStorage == "true";
    }

    /**
     * @description 检查当前缓存的token是否过期(不论实名/匿名)
     * @returns 
     */
    public isExpire(): boolean {
        let currentTime = new Date().getTime();
        let expTime = this.getCache("expire");
        // 过期时间数小于当前时间数,表示token已过期
        return Number(expTime) < currentTime;
    }

    /**
     * @description 
     * @returns 
     */
    public getPartnerType(): string | null {
        return this.getCache("PartnerType");
    }

    /**
     * @description 判断当前Partner是否是内部Partner
     * 是则返回true
     */
    public isInternalPartner(): boolean {
        return this.getPartnerType() == "INTERNAL";
    }

    /**
     * 日志专用的获取用户信息
     * @returns 
     */
    public getLoggerUser(): ILoggerUserInfo | null {
        let loggerUser: ILoggerUserInfo = {};

        loggerUser.userMail = this.getUserName();
        loggerUser.isAnonymous = this.isAnonymous();

        let name = this.getCache("firstName");

        if (name) {
            loggerUser.userName = name;
        }

        if (this.token) {
            loggerUser.tokenType = this.token.token_type;
            loggerUser.accessToken = this.token.access_token;
        }

        loggerUser.anonymousUserId = this.getAnonymousUserId();

        return loggerUser;
    }


    /**
     * @description 设置店铺列表数据
     * @param storeList
     */
    public setStoreList(storeList: Array<Store>) {
        this.setCache(LocalStorageKeyEnum.STORE_LIST, JSON.stringify(storeList));
    }

    /**
     * @description 获取店铺列表数据
     * @param storeList
     */
    public getStoreList(): Array<Store> | undefined {
        const storeListStr = this.getCache(LocalStorageKeyEnum.STORE_LIST) as string;
        return (is.undefined(storeListStr) || storeListStr === "") ? undefined : JSON.parse(storeListStr);
    }

    /**
     * @description 设置店铺列表数据-过期时间
     */
    public setStoreListExpireDate() {
        const currentDate = new Date().getTime();
        const expireDate = currentDate + (15 * 60 * 1000);
        this.setCache(LocalStorageKeyEnum.STORE_LIST_EXPIRE, String(expireDate));
    }

    /**
     * @description 获取店铺列表数据-过期时间
     * @param storeList
     */
    public getStoreListExpireDate(): number | undefined {
        const expireDate = this.getCache(LocalStorageKeyEnum.STORE_LIST_EXPIRE) as string;
        return (is.undefined(expireDate) || expireDate === "") ? undefined : Number(expireDate);
    }

    /**
     * @description 清除店铺列表缓存数据(店铺列表数据，店铺列表数据过期时间)
     */
    public clearStoreList() {
        this.removeCache(LocalStorageKeyEnum.STORE_LIST);
        this.removeCache(LocalStorageKeyEnum.STORE_LIST_EXPIRE);

    }

    // private initHeaderFn() {
    //     this.header.getFirstName = (function() {
    //         return this.getCache("firstName") || "";
    //     }).bind(this)

    //     this.header.getCartQty = (function() {
    //         return this.getCache("CartNumber") || "0";
    //     }).bind(this)

    //     this.header.clearLogin = (function() {
    //         this.removeCache("Token");
    //         this.removeCache("TokenType");
    //         this.removeCache("expire");
    //         this.removeCache("UserName");
    //         this.removeCache("firstName");
    //         this.removeCache("CartNumber");
    //         this.removeCache("IsAnonymous");
    //     }).bind(this)

    //     /**
    //      * @description
    //      * @deprecated
    //      * TODO 临时做法,集成permissionService后去除
    //      */
    //     this.header.setAnonymous = (function(isAnonymous: boolean, anonymousUserId?: string) {
    //         this.setCache("IsAnonymous", isAnonymous.toString());

    //         if (anonymousUserId) {
    //             this.setCache("AnonymousUserId", anonymousUserId);
    //         }
    //     }.bind(this))
    // }
}